import Vue from 'vue'
import * as types from 'store/mutation-types'
import { MARKET_TYPE } from 'const/stock'

const state = {
  shorts: null
}

const getters = {
  metricsShortData(state) {
    return state.shorts || []
  }
}

const mutations = {
  [types.LOAD_METRICS_SHORT_DATA](state, data) {
    state.shorts = data
  },
  [types.CLEAR_METRICS_SHORT_DATA](state) {
    state.shorts = null
  }
}

const actions = {
  loadShortMetricData({ commit, dispatch }, { symbol, market }) {
    dispatch('clearShortMetrics')
    if (market === MARKET_TYPE.US) {
      return Vue.http
        .get(`~stock/stock_info/short_interest/${symbol}`)
        .then(resp => {
          if (resp.data.ret !== 0) {
            return []
          }
          return commit(types.LOAD_METRICS_SHORT_DATA, resp.data.items)
        })
    }
    if (market === MARKET_TYPE.HK) {
      return Vue.http
        .get(`~stock/hkstock/stock_info/short_interest/${symbol}`)
        .then(resp => {
          if (resp.data.ret !== 0) {
            return []
          }
          return commit(types.LOAD_METRICS_SHORT_DATA, resp.data.items)
        })
    }
  },
  clearShortMetrics({ commit }) {
    commit(types.CLEAR_METRICS_SHORT_DATA)
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
